import { Theme } from '@mui/material'

const useStyles = {
  background: (theme: Theme, variant: 'default' | 'alert-acknowledgement') => ({
    backgroundColor: theme.palette.ui.surface1!,
    minHeight: '100vh',
    flexDirection: 'column' as const,
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    ...(variant === 'default'
      ? {
          [theme.breakpoints.down('md')]: {
            minHeight: '100dvh',
            justifyContent: 'flex-start',
          },
        }
      : {}),
  }),
  cardContainer: (theme: Theme, variant: 'default' | 'alert-acknowledgement') => ({
    display: 'flex',
    width: '100%',
    maxWidth: '750px',
    ...(variant === 'default' ? { minHeight: '625px' } : {}),
    position: 'relative' as const,
    flexDirection: 'column' as const,
    alignItems: variant === 'default' ? 'stretch' : 'center',
    flexGrow: variant === 'default' ? 0 : 1,
    minHeight: 0,
    ...(variant === 'default' ? { overflow: 'hidden' } : {}),
    marginY: variant === 'alert-acknowledgement' ? '103px' : '128px',
    bgcolor: variant === 'alert-acknowledgement' ? theme.palette.ui.surface : theme.palette.background.paper,
    [theme.breakpoints.up('md')]: {
      borderRadius: theme.spacing(1.5),
      ...(variant === 'default' ? {} : { overflow: 'hidden' }),
    },
    ...(variant === 'default'
      ? {
          [theme.breakpoints.down('md')]: {
            margin: 0,
            minHeight: '100dvh',
          },
        }
      : {
          [theme.breakpoints.down('md')]: {
            margin: 0,
          },
        }),
  }),
  topAppBar: (theme: Theme) => ({
    position: 'sticky',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    alignSelf: 'stretch',
    zIndex: 2,
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.ui.outlineVariant}`,
    flexShrink: 0,
  }),
  topToolbar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '85px',
  },
  contentContainer: (variant: 'default' | 'alert-acknowledgement') => ({
    display: variant === 'default' ? 'flex' : 'block',
    flexDirection: variant === 'default' ? 'column' : 'row',
    width: '100%',
    flex: '1 0 auto',
    minWidth: 0,
    ...(variant === 'default' ? { minHeight: 0 } : {}),
    overflow: 'visible',
  }),
  contentInner: (variant: 'default' | 'alert-acknowledgement') => ({
    ...(variant === 'default'
      ? {
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
        }
      : {}),
    width: '100%',
    maxWidth: '390px',
    minWidth: 0,
    marginInline: 'auto',
    paddingX: variant === 'alert-acknowledgement' ? 2 : 3,
  }),
  promoFooter: {
    display: 'flex',
    width: '100%',
    alignSelf: 'stretch',
    zIndex: 2,
    background: 'linear-gradient(177deg, #D0E7FF 12.03%, #F8FDFF 88.04%)',
    flexShrink: 0,
    marginTop: 'auto',
  },
  promoFooterContent: (isMobile: boolean) => ({
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
    paddingX: isMobile ? 2 : 3,
    paddingY: 2,
  }),
  promoFooterLeft: {
    gap: 1,
    alignItems: 'center',
    minWidth: 0,
  },
  promoFooterIconWrap: (isMobile: boolean) => ({
    paddingX: isMobile ? 0 : 1,
    height: 56,
  }),
}

export default useStyles
